import RelationshipMetadata from "../../RelationshipMetadata";

class AccountUserAccountUserRoleRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "AccountUserAccountUserRoleRelationshipMetadata";
        this.parentEnterpriseComponent = "AccountUser";
        this.childEnterpriseComponent = "AccountUserRole";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "RoleUSID";
    }
}

export default AccountUserAccountUserRoleRelationshipMetadata;